import React from 'react';
import MediaQuery from 'react-responsive';
import OurDifferenceLanding from 'components/organisms/ourDifferenceLandingScreen';
import OurDifferenceMobileView from 'components/organisms/ourDifferenceLandingScreen/mobileView';

// TODO: Define props

const OurHomesDifferences = props => {
  const { ourDifferenceData, cmsDetailsData } = props.data;

  const { breadcrumbList } = props;

  const infoLinks = [];
  let our_difference_heading = ' ';
  let our_difference_description = ' ';

  for (let i = 0; i < ourDifferenceData.length; i++) {
    let info = {};
    if (
      ourDifferenceData[i].parent_page_title === '' ||
      ourDifferenceData[i].parent_page_title === null
    ) {
      our_difference_heading = ourDifferenceData[i].page_title;
      our_difference_description = ourDifferenceData[i].short_content;
    } else {
      info.data = ourDifferenceData[i];
      info.title = ourDifferenceData[i].page_title;
      info.cms_page_id = ourDifferenceData[i].cms_page_id
        ? ourDifferenceData[i].cms_page_id
        : '';
      info.link = '#';
      info.id = infoLinks.length;
      infoLinks.push(info);
    }
  }
  return (
    <div id={'our-differences'}>
      <MediaQuery maxDeviceWidth={575.6}>
        <OurDifferenceMobileView
          cmsDetailsData={cmsDetailsData}
          our_difference_heading={our_difference_heading}
          our_difference_description={our_difference_description}
          infoLinks={infoLinks}
          breadcrumbList={breadcrumbList}
        />
      </MediaQuery>
      <MediaQuery minDeviceWidth={576}>
        <OurDifferenceLanding
          cmsDetailsData={cmsDetailsData}
          our_difference_heading={our_difference_heading}
          our_difference_description={our_difference_description}
          infoLinks={infoLinks}
          heading_classname={'our-difference-heading'}
          breadcrumbList={breadcrumbList}
        />
      </MediaQuery>
    </div>
  );
};

export default OurHomesDifferences;
